/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  SystemSettingKey,
  SystemSettingResponse,
  UpdateSystemSettingRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SystemSettingKeyFromJSON,
    SystemSettingKeyToJSON,
    SystemSettingResponseFromJSON,
    SystemSettingResponseToJSON,
    UpdateSystemSettingRequestFromJSON,
    UpdateSystemSettingRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface GetSystemSettingRequest {
    key: SystemSettingKey;
}

export interface UpdateSystemSettingOperationRequest {
    key: SystemSettingKey;
    updateSystemSettingRequest: UpdateSystemSettingRequest;
}

/**
 * SystemSettingsApi - interface
 * 
 * @export
 * @interface SystemSettingsApiInterface
 */
export interface SystemSettingsApiInterface {
    /**
     * 
     * @param {SystemSettingKey} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemSettingsApiInterface
     */
    getSystemSettingRaw(requestParameters: GetSystemSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemSettingResponse>>;

    /**
     */
    getSystemSetting(requestParameters: GetSystemSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemSettingResponse>;

    /**
     * 
     * @param {SystemSettingKey} key 
     * @param {UpdateSystemSettingRequest} updateSystemSettingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemSettingsApiInterface
     */
    updateSystemSettingRaw(requestParameters: UpdateSystemSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemSettingResponse>>;

    /**
     */
    updateSystemSetting(requestParameters: UpdateSystemSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemSettingResponse>;

}

/**
 * 
 */
export class SystemSettingsApi extends runtime.BaseAPI implements SystemSettingsApiInterface {

    /**
     */
    async getSystemSettingRaw(requestParameters: GetSystemSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemSettingResponse>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getSystemSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/system-settings/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemSettingResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSystemSetting(requestParameters: GetSystemSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemSettingResponse> {
        const response = await this.getSystemSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateSystemSettingRaw(requestParameters: UpdateSystemSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemSettingResponse>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateSystemSetting().'
            );
        }

        if (requestParameters['updateSystemSettingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSystemSettingRequest',
                'Required parameter "updateSystemSettingRequest" was null or undefined when calling updateSystemSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/system-settings/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSystemSettingRequestToJSON(requestParameters['updateSystemSettingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemSettingResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateSystemSetting(requestParameters: UpdateSystemSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemSettingResponse> {
        const response = await this.updateSystemSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
